import React, { useState, useEffect } from "react";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";
import { DatePickerInput } from "rc-datepicker";
import { FormGroup } from "react-bootstrap";

const PmSitiesFilterForm = ({
  applyFilter,
  siteTypes=[],
  statusTypes=[],
  reportees=[],
  statusId,
  isRoleId,
  dashboard=false,
  pmApprovalList=false,
  city=[],
}) => {
  const filterInputs = {
    site_no: "",
    project_id: "",
    client_name: "",
    site_type: "",
    status: statusId,
    assignee_ids: "",
    fromDate: "",
    toDate: "",
    city_id: "",
    commercial_type_id:''
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
  const [listStatus, setListStatus] = useState("");
  const [isFocus2, setIsFous2] = useState(false);
  const [isFocus3, setIsFous3] = useState(false);

  const handleDateChange2 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      fromDate: dateString,
    });
  };
  const handleDateChange3 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      toDate: dateString,
    });
  };

  const handleDateHide2 = () => {
    if (!filterFieldsData.fromDate) {
      setIsFous2(true);
    }
  };
  const handleDateHide3 = () => {
    if (!filterFieldsData.toDate) {
      setIsFous3(true);
    }
  };

  useEffect(() => {
    setFilterFieldsData({...filterFieldsData, status : statusId})
    localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
  }, [statusId])

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(
        localStorage.getItem("applyFilter") &&
          localStorage.getItem("applyFilter")
      );
     
      if (roles) {
        setFilterFieldsData(roles);

      }
    })();
  }, []);


 

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        setFilterFieldsData({...filterFieldsData, status: statusId});
        applyFilter(filterFieldsData);
        filterFieldsData && localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
        
      }}
    >
      {console.log(isRoleId)}
      {dashboard === false && 
      <>
      <ConstantInput
        label={localization.siteNumber}
        value={filterFieldsData.site_no}
        regex={Regex.alphaNum.test(filterFieldsData.site_no)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, site_no: val })
        }
      />
      <ConstantInput
        label={localization.projectId}
        value={filterFieldsData.project_id}
        regex={Regex.alphaNum.test(filterFieldsData.project_id)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, project_id: val })
        }
      />
      <ConstantInput
        label={localization.clientName}
        value={filterFieldsData.client_name}
        regex={Regex.text.test(filterFieldsData.client_name)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, client_name: val })
        }
      />

      <DropDownInput
        disabled={siteTypes.length === 0}
        label={localization.siteType}
        data={siteTypes}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, site_type: val.id })
        }
      />
       {/* {city.length !== 0 ? 
          <DropDownInput
          disabled={city.length === 0}
          label={localization.geoCity}
          data={city}
          getIdValue={(val) =>
            setFilterFieldsData({ ...filterFieldsData, city_id: val.id })
          }
        />
          : ''} */}
      {(pmApprovalList) ? 
          <DropDownInput
          label="Select Status"
          data={[
          {
            "id": 4,
            "name": "Approval Pending"
          },
          {
            "id": 5,
            "name": "Approved"
          },
          {
            "id": 7,
            "name": "Rejected"
          },
        ]}
          getIdValue={(val) =>
            setFilterFieldsData({ ...filterFieldsData, status: val.id })
          }
        />
      :
           <DropDownInput
              label="Select Status"
              data={[{
                "id": 1,
                "name": "Open"
              },
              {
                "id": 2,
                "name": "In Schedule"
              },
              {
                "id": 3,
                "name": "In Progress"
              },
              {
                "id": 4,
                "name": "Approval Pending"
              },
            ]}
              getIdValue={(val) =>
                setFilterFieldsData({ ...filterFieldsData, status: val.id })
              }
            />
      }
      
      {/* <DropDownInput
        disabled={assignedAreas.length === 0}
        label={localization.assignedArea}
        data={assignedAreas}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, assigned_area: val.id })
        }
      /> */}
      {isRoleId !== 9 && (
      <DropDownInput
        disabled={reportees.length === 0}
        label={localization.assignee}
        data={reportees}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, assignee_ids: val.id })
        }
      />
      )}
      </>
      }

      {/* <DropDownInput
          label={localization.commercialType}
          data={[
            {id: 5, name: "Capex",},
            {id: 6, name: "Opex-Ownership",},
            {id: 7, name: "Rental",},
          ]}
          getIdValue={(val) =>{
            setFilterFieldsData({
              ...filterFieldsData,
              commercial_type_id: val.id,
            })
          }
          }
      /> */}
         {/* <fieldset>
        <h4>{localization.createdBetween}</h4> */}

        <FormGroup
          className={`date custom_date_picker ${isFocus2 ? "active-date" : ""}`}
        >
          <DatePickerInput
            onChange={handleDateChange2}
            value={filterFieldsData.fromDate}
            autoClose
            onShow={() => setIsFous2(true)}
            onHide={handleDateHide2}
            closeOnClickOutside
            showOnInputClick
            locale="en"
            className="my-custom-datepicker-component"
            displayFormat="DD-MM-YYYY"
            returnFormat="DD-MM-YYYY"
            // maxDate={new Date()}
          />
          <label>{'Schd. Mnt. Date'}</label>
        </FormGroup>

        {/* <FormGroup
          className={`date custom_date_picker ${isFocus3 ? "active-date" : ""}`}
        >
          <DatePickerInput
            onChange={handleDateChange3}
            value={filterFieldsData.toDate}
            autoClose
            onShow={() => setIsFous3(true)}
            onHide={handleDateHide3}
            closeOnClickOutside
            showOnInputClick
            locale="en"
            className="my-custom-datepicker-component"
            displayFormat="DD-MM-YYYY"
            returnFormat="DD-MM-YYYY"
            // maxDate={new Date()}
          />

          <label>{localization.toDate}</label>
        </FormGroup>
      </fieldset> */}
      
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br/>
        <br/>
        <button
          onClick={() => {
            localStorage.setItem("applyFilter", JSON.stringify(filterInputs));
            applyFilter(filterInputs);
            localStorage.setItem("statusFilter", JSON.stringify({}));
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default PmSitiesFilterForm;
